import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaSetDefinition } from './TypedDefinition'

export const SchemaSetPlugin = createSchemaPlugin(
  'Schema.Set',
  SchemaSetDefinition
)
